import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)
import { environment } from 'environments/environment';

@Injectable()
export class AggregatorTransferAdmissionService extends ServiceBase {

    constructor(private _http: HttpClient) {
        super();
    }

    transferAdmission = (data): Observable<any> => {
        return this._http.post<any>(`${environment.httpAggregatorApi}TransferAdmittedPatientSection`, JSON.stringify(data))
    }
}
